import React, { useEffect } from "react";
import { useParams } from "react-router";
import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import { PageContent } from "../../styles/global/Pages.styled";
import { RegisterComponent } from "../Global/Organism/RegisterDetail/RegisterComponent";
import { RegistryGlobalSubTabs } from "../Global/Organism/RegisterDetail/RegisteryGlobalSubTabs";

export const RegisterDetail = () => {
  const { id } = useParams();

  const {
    data: itemData,
    remove: removeItemData,
  } = useFetch("/registry", "itemData", {
    id: id
  }, null, null, query.middlewareURL);

  useEffect(() => {
    return () => {
      removeItemData();
    };
  }, [removeItemData]);

  return (
    <PageContent style={{ height: '100%' }}>
      {itemData ?
        <RegisterComponent item={itemData} tabsHelper={RegistryGlobalSubTabs} />
        : null}
    </PageContent>
  );
};